<template>
  <div class="record-bg">
    <h2 class="page-title">月票登記抽籤</h2>

    <div class="record-container">
      <div v-for="(lottery, index) in lottories" :key="index" class="record-item">
        <span>{{ lottery.title }}</span>
        <button class="view-button" @click="viewDetails(lottery.link)">查看</button>
      </div>
    </div>
  </div>
  <ContactFooter />
</template>

<script>
import ContactFooter from '@/components/ContactFooter.vue';
import PullDAO from '@/services/PullDAO'; // Import the PullDAO

export default {
  name: 'UserRecord',
  components: {
    ContactFooter,
  },
  data() {
    return {
      lottories: [], // Array to store the fetched lottery results
    };
  },
  methods: {
    /**
     * Fetches the lottery results using PullDAO and updates the component state.
     */
    async fetchLottories() {
      const pullDAO = new PullDAO();
      try {
        const response = await pullDAO.listLottories(10, 1); // Fetch 10 records, page 1
        console.log('Fetched lottery results:', response);
        this.lottories = response.lottories; // Assuming response.data contains the list of lottery results
      } catch (error) {
        console.error('Error fetching lottery results:', error);
      }
    },

    /**
     * Handles the "查看" button click and performs a custom action.
     * @param {string} id - The ID of the selected lottery.
     */
    viewDetails(link) {
      console.log('Opening link:', link);
      window.open(link, '_blank');
    },

  },
  async mounted() {
    await this.fetchLottories(); // Fetch lottery results when the component is mounted
  },
};
</script>

<style scoped>
.record-bg {
  background-color: var(--background-gray);
  height: 100vh;
}

.record-container {
  width: var(--home-component-width);
  margin: 0 auto;
  /* Center the container */
  padding: 20px;
}

.page-title {
  margin-bottom: 40px;
}

.record-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  padding: 40px;
  margin-bottom: 20px;
  border-radius: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-size: 1.3rem;
  color: var(--font-gray);
  font-weight: bold;
  height: 4rem;
}

.record-item span {
  /* //styleName: 2xl/bold; */
  font-family: Inter;
  font-size: 24px;
  font-weight: 700;
  line-height: 33.6px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--gray15);
}

.view-button {
  background-color: var(--green03);
  color: white;
  border: none;

  padding: 16px 32px 16px 32px;
  border-radius: 99px;

  /* //styleName: lg/bold; */
  font-family: Inter;
  font-size: 18px;
  font-weight: 700;
  line-height: 26.1px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  cursor: pointer;
}

.view-button:hover {
  background-color: var(--green01);
}

/* Responsive design for screens less than 560px wide */
@media (max-width: 560px) {

  .page-title {
    margin-bottom: 20px;
  }

  .record-container {
    max-width: 343px;
    /* Set container width to 343px */
  }

  .record-item {
    padding: 20px;
    /* font-size: 1rem; */
    height: auto;
    /* Allow height to adjust based on content */
  }

  .record-item span {
    /* //styleName: md/bold; */
    font-family: Inter;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    /* Adjust font size */
  }

  .view-button {
    padding: 8px 16px 8px 16px;

    /* //styleName: xs/bold; */
    font-family: Inter;
    font-size: 12px;
    font-weight: 700;
    line-height: 18.48px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

  }
}
</style>
